import { render, staticRenderFns } from "./chatGood.vue?vue&type=template&id=6f80bbb5&scoped=true"
import script from "./chatGood.vue?vue&type=script&lang=js"
export * from "./chatGood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f80bbb5",
  null
  
)

export default component.exports